import $ from 'jquery';

$.pad = (string, len, pad, right) => {
  return right ? `${string}`.padEnd(len, pad) : `${string}`.padStart(len, pad);
};

$.parseNumber = (string) => {
  const v = parseFloat(string.trim().replace(/\./g, '').replace(',', '.'));
  return isNaN(v) ? 0.0 : v;
};

$.formatNumber = (number, decimals = 2) => {
  const zeroes = $.pad('', decimals, '0');
  const rf = parseInt('1' + zeroes, 10);
  let p = '' + Math.round(parseFloat(number) * rf) / rf;
  if (p.indexOf('.') == -1) p = [p, '.'].join('');
  const ps = [p, zeroes].join('').split('.');
  const s = ps[0];
  const n = [];
  const l = s.length;
  for (var i = l; i > 0; i--) {
    if (i != l && (l - i) % 3 == 0) n.unshift('.');
    n.unshift(s.charAt(i - 1));
  }
  return n.concat([',', ps[1].substring(0, decimals)]).join('');
};
